import { FC, ReactNode } from 'react';
import classNames from 'classnames';
import Flex from '../Flex.tsx';

type Props = {
  head: ReactNode;
  rightBlock: ReactNode;
  children: ReactNode;

  contentToTop?: boolean;
};

const FormLayout: FC<Props> = ({ head, rightBlock, children, contentToTop }) => (
  <Flex.Wrapper className={classNames('h-[100dvh] flex-col 800:flex-row bg-secondary')}>
    <Flex.Wrapper
      column
      className="relative 800:overflow-y-auto flex-1 800:basis-[628px] 1440:basis-[686px]"
    >
      {head}

      <Flex.Wrapper
        column
        jBetween
        gap="40px"
        className={classNames('!max-w-[730px] w-full flex-1 container-x', 'pb-[24px] pt-[88px]')}
      >
        {!contentToTop && <div />}

        {children}
      </Flex.Wrapper>
    </Flex.Wrapper>

    {rightBlock}
  </Flex.Wrapper>
);

export default FormLayout;
